const modules = {}
const context = require.context('./modules', false, /\.js$/)

context.keys().map(key => {
  const namespace = key.replace(/(\.\/)|(\.js)/g, '')
  const module = context(key).default
  modules[namespace] = {
    namespaced: true,
    ...module,
  }
})

export default modules
